export default __webpack_public_path__ + "static/media/coinFuPanda.44c67d88.png";